export default {
  getGST: state =>  {
    return state.gst
  },
  getCurrentGST: state =>  {
    return state.currentGST
  }
}